import { StatsigSingleton } from '@laam/statsig-client';

export const checkoutHeaders = (
	deliverToCountry: string,
	email: string,
	loganId: string,
) => {
	return {
		'Content-Type': 'application/json',
		'X-Country': deliverToCountry,
		'stable-id': process.client ? StatsigSingleton.getStableID() : '',
		'X-Email': email,
		'X-User': loganId,
	};
};
